import useQuickLinkToken from "./useQuickLinkToken";

export default () => {
  const quickLinkToken = useQuickLinkToken();
  return !!quickLinkToken;
}